<template>
  <div class="mp text-center" v-title data-title="查价格升级啦~">
    <van-notice-bar
      left-icon="volume-o"
      text="查价格升级啦~扫描下方小程序码或者微信搜索“水产圈子”小程序立即体验"
      color="#fff590"
      background="#b71831"
    />
    <div class="padding10 fs2">
      <!-- <ul style="list-style: disc;">
        <li>想更及时查看水产行情</li>
        <li>想打开收购或者销售渠道扩展自己的水产人脉圈子</li>
        <li>想了解市场买卖情况并发布自己买卖信息的</li>
      </ul> -->
    </div>
    <div class="text-center">
      <img width="65%" style="max-width: 400px" src="../../assets/mp.png">
    </div>
    <div class="font-bold pt7">查价格已升级为小程序版</div>
    <div class="font-bold pt5">
      <div v-if="isWeixin" style="font-size: 18px;padding-bottom:5px">
       长按或扫描上方小程序码前往“水产圈子”小程序
      </div>
      <div v-else>
        扫描上方水产圈子小程序码
      </div>
      或者微信搜索“水产圈子”小程序立即体验
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import { isWeixin } from '@/uitls/checkUtil';

export default Vue.extend({
  name: 'UserList',
  components: {},
  data() {
    return {
      isWeixin: isWeixin(),
    };
  },
  methods: {
  },
  created() {
  },
});
</script>
<style scoped>
.mp{
  min-height: 100vh;
  background-color: #ffffff;
}
</style>
